import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const KEY = 'atf_cookie_consent_v1';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (val) => {
    localStorage.setItem(KEY, val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[80] animate-fade-up">
      <div className="card-dark rounded-2xl p-5 shadow-2xl border border-fire-gold/30 relative">
        <button
          onClick={() => decide('dismissed')}
          aria-label="Close"
          className="absolute top-3 right-3 text-fire-cream/40 hover:text-fire-goldlight transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-fire-maroon/30 border border-fire-gold/30 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-fire-goldlight" strokeWidth={1.6} />
          </div>
          <div>
            <h4 className="font-display text-lg text-fire-cream mb-1">We use cookies</h4>
            <p className="text-fire-cream/60 font-body text-sm leading-relaxed">
              We use cookies to remember your bag and improve your experience by the fire. See our{' '}
              <Link to="/privacy" className="text-fire-goldlight underline underline-offset-2 hover:text-fire-gold">Privacy Policy</Link>.
            </p>
            <div className="flex gap-3 mt-4">
              <button onClick={() => decide('accepted')} className="btn-gold rounded-full px-5 py-2 text-sm font-semibold">
                Accept
              </button>
              <button onClick={() => decide('declined')} className="btn-outline-gold rounded-full px-5 py-2 text-sm font-semibold">
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
